module.exports = __webpack_public_path__ + "./fonts/lato-regular-webfont.ttf";


//////////////////
// WEBPACK FOOTER
// ./Content/fonts/lato-regular-webfont.ttf
// module id = 24
// module chunks = 0